export default {
    zhiboguanli: "直播管理",
    shipinguanli: "视频管理",
    dingyuezheguanli: "订阅者管理",
    gerenzhongxin: "个人中心",
    rili: "日历",
    quanbuzhibo: "全部直播",
    weikaishi: "未开始",
    yijieshu: "已结束",
    zhibosousuo: "请输入想要搜索的直播标题",
    haiweikaishi: "还未开始",
    jinruzhibo: "进入直播",
    chakanhuifang:"查看回放",
    quanbushipin: "全部视频",
    shenhezhong: "审核中",
    weitongguo: "未通过",
    yifabu: "已发布",
    shipinsousuo: "请输入想要搜索的直播标题",
    wodedingyuezhe: "我的订阅者",
    xingming: "姓名",
    suozaiguojia: "所在国家",
    nianling: "年龄",
    xueshengmuyu: "学生母语",
    xingqudian: "兴趣点",
    yuyandengji: "语言等级",
    canyupingtaishichang: "参与平台直播总时长",
    sousuoxuesheng: "请输入想要搜索的学生姓名",
    huanying:"您好，欢迎来到",
    beelink:"Beelink",
    meiyouzhanghao:"还没有账号？",
    yiyouzhanghao:"已有账号？",
    qudenglu:"去登录",
    chengweilaoshi:"成为一名Beelink老师",
    shoujidenglu:"手机号登录",
    mimadenglu:"账号密码登录",
    shoujihao:"手机号",
    yanzhengma:"验证码",
    dianjihuoquyzm:"点击获取验证码",
    lijidenglu:"立即登录",
    shurushouji:"请输入您的手机号",
    shuruyzm:"请输入您的验证码",
    banquan:"成都之字空动科技有限公司版权所有 2019—2022",
    zhanghao:"帐号",
    shuruzhanghao:"请输入您的邮箱或者手机号",
    shuruzhanghaol:"请输入您的邮箱或者国家号+手机号（86186xxx）",
    mima:"密码",
    shurumima:"请输入您的密码",
    wangjimima:"忘记密码?",
    yiwanxinlai:"亿万人的信赖和见证",
    kaiqishenghuo:"Beelink 开启您的美好学习生活",
    kaiqishenghuo1:"开启您的美好学习生活",
    guanyubeelink:"关于 Beelink",
    guanyuneirong:" Beelink平台拥有数千名优秀老师，丰富的教育经验和有趣的课堂环境，一对一辅导平台的教务管理、线上课堂、线下课堂、助学互动，课程回放等多项教学功能，让您利用碎片时间，轻轻松松学会各种语言。",
    liaojiegengduo:"了解更多",
    xiayibu:"下一步",
    tongyixieyi:"勾选表示同意 《用户注册协议和隐私政策》",
    shezhimima:"设置密码",
    shurumimatwo:"请再次输入您的密码",
    shuruxingming:"请输入您的姓名",
    youxiang:"邮箱",
    shuruyouxiang:"请输入您的邮箱",
    muyu:"母语",
    shurumuyu:"请输入您的母语",
    jiaoshou:"教授",
    xuanzejiaoshou:"请选择您的教授",
    lijizhuce:"立刻注册",
    wanchengzhuce:"您已完成注册",
    qudangan:"恭喜您注册成功，点击跳转到我的档案页面",
    yanzhengshouji:"验证手机号",
    tianxiexinxi:"填写帐号信息",
    fanhuishangyibu:"返回上一步",
    zhucewancheng:"帐号注册完成",
    xiangqimima:"想起密码？",
    zhanghuming:"账户名",
    chongzhimima:"重置密码",
    chongzhishurumima:"请输入您要设置的密码",
    querenmima:"确认密码",
    querenchongzhi:"确认重置",
    wanchengchongzhi:"您已完成密码重置",
    chongzhichenggong:"恭喜您重置密码成功，点击跳转到登录页面",
    shibiezhanghao:"识别账号",
    yanzhengxinxi:"验证账号信息，重置密码",
    chongzhiwancheng:"密码重置完成",
    xiugaitouxiang:"修改头像",
    xiugai:"修改",
    shuruxinnicheng:"请输入新的昵称",
    jibenxinxi:"基本信息",
    laiziguojia:"来自国家或地区",
    juzhudi:"居住地",
    shurujuzhudi:"输入居住地",
    wohaihuishuo:"我还会说",
    shuliandu:"熟练度",
    jixutianjia:"继续添加",
    xindemuyu:"请输入新的母语",
    duanshipin:"短视频介绍",
    shipinyaoqiu:"视频要求：",
    shipinyaoqiu1:"上传视频时间要求为30s之内",
    shipinyaoqiu2:"支持文件大小100M",
    shipinyaoqiu3:"文件扩展名：flv、mp4、mov、avi、wav",
    fengmianyaoqiu:"封面要求：",
    fengmianyaoqiu1:"文件扩展名：jpg，png",
    fengmianyaoqiu2:"文件大小限制：2M",
    ziwojieshao:"自我介绍",
    lianxifangshi:"联系方式",
    genghuanshoujihao:"更换手机号",
    xitongshezhi:"系统设置",
    shiqu:"时区",
    huobi:"货币",
    yuyan:"语言",
    wanchengrenzheng:"请完成以下认证",
    shuru:"请输入",
    shoudaodeyzm:"收到的验证短信码",
    shoujiyanzhengma:"手机验证码",
    huoquyanzhengma:"获取验证码",
    bangdingxinhaoma:"完成以下操作，绑定新号码",
    bangdingshouji:"绑定手机",
    xiugaizhanghaomima:"完成以下操作，修改账号密码",
    yuanmima:"原密码",
    xinmima:"新密码",
    xinmimatwo:"确认新密码",
    xiugaimima:"修改密码",
    baocun:"保存信息",
    gerenjieshao:"请输入个人介绍",
    shangchuanshipin:"上传视频",
    shangchuanshipint:"上传视频",
    shipinbiaoti:"视频标题",
    shurushipinbiaoti:"请输入您的视频标题",
    shipinfengmian:"视频封面",
    xuanzeshipin:"选择视频",
    shipinjianjie:"视频简介",
    shurushipinjianjie:"请输入您的视频简介",
    zhiboxinxi:"直播信息",
    zhibobiaoti:"直播标题",
    shuruzhibobiaoti:"请输入您的直播标题",
    zhibofengmian:"直播封面",
    shipinjieshao:"视频文件",
    vshipinjieshao:"视频介绍",
    kaishishijian:"开始时间",
    shezhikaishishijian:"请设置您的开始时间",
    zhiboshichang:"直播时长",
    shuruzhiboshijian:"请输入直播时间",
    fenzhong:"分钟",
    zhiborenshu:"直播人数",
    shuruzhiborenshu:"请输入直播人数",
    zhibojianjie:"直播简介",
    shuruzhibojianjie:"请输入您的直播简介",
    fabuzhibo:"发布直播",
    fabuzhibob:"发布直播",
    wuzhibozige:"您尚未获得直播资格",
    yijianfankui:"意见反馈",
    fen:"分",
    shipinshuju:"视频数据",
    shangchuanshijian:"上传时间：",
    bofangliang:"播放量",
    zhuanfaliang:"转发量",
    zhuangtai:"状态",
    shenheing:"正在审核中，情耐心等待",
    shenheweitongguo:"审核未通过",
    yuanyin:"原因",
    yuanyintext:"您的视频中含有大量敏感词汇，请修改后再次上传，感谢您对Beelink的技术支持",
    xiugaishipin:"修改该视频",
    shanchushipin:"删除该视频",
    querenshanchu:"您确认删除该视频吗？",
    shipinpingjia:"该视频评价",
    fabiaoliuyan:"发表留言",
    shuruliuyan:"请输入您的看法和见解",
    suoyouhuifu:"查看所有回复",
    huifu:"回复",
    shanchu:"删除",
    xiabanyayu:"西班牙语",
    bianjixinxi:"编辑信息",
    kaishizhibo:"开始直播",
    shangkexuesheng:"上课学生",
    chakanxiangqing:"查看详情",
    canjiashichang:"参加时长",
    quxiaozhibo:"取消直播",
    yijujue:"已拒绝",
    jujueyuanyintext:"请输入您拒绝该学生参与直播的原因",
    juejueyuanyin:"拒绝原因",
    querenjujue:"确认拒绝",
    zhiboyemian:"直播页面",
    querenguanbi:"您确认关闭直播吗",
    dingyuezhe:"我的订阅者",
    sousuodingyue:"请输入想要搜索的学生姓名",
    wodeqianbao:"我的钱包",
    lijitixian:"立即提现",
    tixianjilu:"提现记录",
    bangdingyonghu:"绑定用户",
    zhanghuyue:"账户余额",
    tianjiazhanghu:"添加新的账户",
    yinhangka:"银行卡",
    zhifubao:"支付宝",
    weixin:"微信",
    zhanghao0:"帐号",
    tixianzhanghu:"提现到指定账户",
    yue:"余额",
    xuanzezhanghu:"选择账户",
    tixianjine:"提现金额",
    quanbujine:"全部金额",
    yueshu:"您的余额只有",
    zuiditixian:"最低提现金额",
    mingxichaxun:"明细查询",
    kaishiriqi:"请选择开始日期",
    jieshuriqi:"请选择结束日期",
    zhanghu:"账户",
    tijiaoriqi:"提交日期",
    jine:"金额",
    caozuo:"操作",
    jiaoyimingxixiangqing:"交易明细详情",
    leixing:"类型",
    zhiboshouru:"直播收入",
    tixian:"提现",
    houtaichongzhi:"后台充值",
    liushuihao:"流水号",
    riqi:"日期",
    laiyuan:"来源",
    fanhui:"返回",
    tixianjiluxiangqing:"提现记录详情",
    daozhangjine:"到帐金额",
    shouxufei:"手续费",
    tixianzhuangtai:"提现状态",
    yuanyinmiaoshu:"原因描述",
    mingcheng:"名称",
    shoukuanzhanghu:"收款账户",
    quanbu:"全部",
    shouru:"收入",
    zhichu:"支出",
    xinzengzhanghu:"新增账户",
    shurukahao:"请输入收款人储蓄卡号",
    kahao:"卡号",
    kaihuhang:"开户行",
    shurukaihuhang:"请输入开户行",
    shuruzhifubao:"请输入支付宝账号",
    saomabangding:"扫码绑定",
    zhu:"注",
    weixinbangding:"打开手机微信扫描左侧二维码 进行微信账户绑定",
    yinhangzhanghu:"银行账户",
    yinhangbic:"银行BIC码",
    tijiao:"提交",
    zhiboliebiao:"直播列表",
    zhibokecheng:"直播课程",
    canyurenshu:"参与人数",
    kechengpingfen:"课程评分",
    shipinliebiao:'视频列表',
    fabushipin:"发布视频",
    zongguankanshu:"总观看数",
    pingjundefen:"平均得分",
    dingyueliebiao:"订阅列表",
    dingyuerenshu:"订阅人数",
    fuwutiaokuan:"关于我们",
    yinsizhengce:"隐私政策",
    shurufankui:"请输入您的意见反馈",
    tijiaofankui:"提交反馈",
    tuichu:"帐号退出",
    wodedangan:"我的档案",
    liebiaotongji:"列表统计",
    guanyu:"关于Beelink",
    xuanzehuifuxuesheng:"请先选择回复的学生",
    shoujihaoweikong:"手机号不能为空",
    zhanghaoweikong:"帐号不能为空",
    mimaweikong:"密码不能为空",
    shoujihaoyouwu:"手机号码有误，请重填",
    yanzhengmaweikong:"验证码不能为空",
    yonghubucunzai:"用户不存在",
    wanshanxinxi:"请先完善相关信息",
    mimabuyizhi:"两次密码输入不一致，请重新输入",
    yanzhengmayouwu:"验证码有误，请重新输入",
    xingmingweikong:"姓名不能为空",
    youxiangweikong:"邮箱不能为空",
    muyuweikong:"母语不能为空",
    jiaoshouweikong:"请选择教授语言",
    weitongyixieyi:"请同意用户协议",
    yuanmimaweikong:"原密码不能为空",
    youxiangcuowu:"邮箱格式有误",
    kongzhanghaoliebiao:"您的账户列表为空，请先添加",
    yuebuzu:"余额不足",
    wenjiangeshi:"文件必须是视频格式",
    biaotiweikong:"标题不能为空",
    fengmianweikong:"封面不能为空",
    wenjianweikong:"视频文件不能为空",
    jianjieweikong:"视频简介不能为空",
    fengmiangeshi:"上传封面文件必须是图片格式",
    zhibobiaotiweikong:"直播标题不能为空",
    zhibofengmianweikong:"直播封面不能为空",
    shipinjieshaoweikong:"视频介绍不能为空",
    kaishishijianweikong:"开始时间不能为空",
    zhiboshichangweikong:"直播时长不能为空",
    zhiborenshuweikong:"直播人数不能为空",
    zhibojianjieweikong:"直播简介不能为空",
    wuzhibozigeale:"您尚未获得直播资格",
    shipinjieshaoccuowu:"视频介绍的文件格式错误",
    buzhichitonghua:"您的浏览器不支持视频通话，请下载新版chrome浏览器",
    bendiliushibai:"本地流发布失败",
    bendiliuchenggong:"本地流发布成功",
    chushihuachenggong:"初始化本地流成功",
    chushihuashibai:"初始化本地流失败",
    buzhichifenxiang:"您的浏览器不支持屏幕分享，请下载新版chrome",
    xuanzefenxiangneirong:"请选择分享的内容",
    guanbishibai:"关闭失败",
    kahaoweikong:"卡号不能为空",
    kaihuhangweikong:"开户行不能为空",
    shensu:"申诉",
    querenquxiao: "您确认取消直播吗？",
    tianjiatixian: "添加提现账户",
    shijirenshu: "实际直播人数",
    shijishichang: "实际直播时长",
    cshipinyaoqiu1: "视频长度不能超过10分钟",
    cshipinyaoqiu2: "视频大小不能超过500m",
    shangchuanwancheng: "请等待文件上传完成",
    zhanghaocunzai: "该手机已注册学生端账号",
    shuoruguize: "收入规则说明",
    shouru1: "直播收入=实际参加学生数x参加时长x单价",
    shouru2: "单价：1对1，20欧/小时；1对N，10欧/小时/人（1<N<=4）",
    shouru3: "请注意，货币一旦修改，不能变动",
    shouru4: "当天直播收益，次日后台审核成功后进入钱包。",
    shouru5: "实际参加时长不超过老师发布直播课程的时长。",
    tishi: "提示",
    querentuichu: "您确认退出？",
    huobitishi: "请注意，货币一旦修改，不能变动。",
    zhuanmazhong: "转码中",
    leixingcuowu:"文件类型错误",
    zuida:"最大",
    zhibotishi1:"恭喜您在Beelink有直播课资格",
    shipindianjiliang: "视频点击量",
    paiming: "排名",
    wo: "我",
    yizhucexuesheng: "该手机已注册学生端账号",
    zhouri:"周日",
    zhouyi:"周一",
    zhouer:"周二",
    zhousan:"周三",
    zhousi:"周四",
    zhouwu:"周五",
    zhouliu:"周六",
    shangyige:"上一月",
    xiayige:"下一月",
    nian:"年",
    yues:"月",
    zhourili:"周日历",
    yuerili:"月日历",
    shangyizhou:"上一周",
    xiayizhou:"下一周",
    guanyuwomen:"成都之字空动科技有限公司成立于2020年7月，是一家致力于语言类教学模式创新的公司。Beelink是我公司网上教学及视频分享平台的品牌，旨在连接母语老师和学生，并为他们搭建一个免费的语言学习分享和在线课程的平台。学生可以通过该平台学习语言类知识，观看教学视频，并且通过免费直播课与母语老师进行线上教学互动，创造一个线上的语言环境。老师则可以通过该平台线上授课，发布教学视频。目前，Beelink已经开通了西语教学板块，在不久的将来我们会增设其他语言类型。",
    xinlangweibo:"新浪微博",
    qingxuanzefenxiangtujing:"请选择分享途径",
    lijifenxiang:"立即分享",
    zhibobaomingxuesheng:"直播报名学生",
    chaoguoshijian:"已经超过7天，无法回看。",
    queding:"确定",
    lianxib:"联系Beelink",
    guanyudesc:"Beelink—专致于外语学习的在线互动学习平台。Beelink汇聚各国名师资源。",
    fuwurexian:"24小时服务热线",
    youxiangb:"Beelink邮箱",
    chuanzhen:"传真",
    appxiazai:"Beelink App下载",
    shichangtishi:"",
    renshutishi: '',
    tixianzhu:"",
    zhibotishi:"",
    zhiboshijian:""
}